import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './CheckBox.css'
import i18next from 'i18next';

function mapStateToProps({ field }) {
  return {
    validation: field
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
};

class _CheckBox extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        type: PropTypes.string,
        class: PropTypes.string,
        title: PropTypes.string,
        placeholder: PropTypes.string,
        optional: PropTypes.bool,
        hasWarning: PropTypes.bool,
        isConfirmed: PropTypes.bool,
        disabled: PropTypes.bool,
        isInvalid: PropTypes.bool,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func,
        value: PropTypes.bool,
        className: PropTypes.string,
        regExPattern: PropTypes.string,
        style: PropTypes.object,
        validation: PropTypes.object
    };

    render() {
      const local = i18next.t('validationMsg', {returnObjects: true});
        const className = classNames(
          "chk_container", {"Disabled": this.props.disabled,
            "chk_confirmation": this.props.isConfirmed,
            "chk_warning": this.props.hasWarning,
            "chk_error": this.props.isInvalid},
          this.props.className
        );
        const placeholder = (this.props.placeholder ? this.props.placeholder : "") + (this.props.optional ? ' (Optional)' : '');
        const disabled = this.props.disabled && true ? 'disabled' : false;
    
        return (
            <React.Fragment>
              <div className={className} style={this.props.style}>
                <input
                  className={classNames("chk_input", this.props.validation[this.props.name] && "chk_error_message")}
                  name={this.props.name}
                  type={'checkbox'}
                  onBlur={event => {
                    if (this.props.onBlur) this.props.onBlur(event);
                  }}
                  onChange={event => {
                    if (this.props.onChange) this.props.onChange({target: {name: this.props.name, value: event.target.checked ? "true" : ""}});
                  }}
                  checked={this.props.value}
                  placeholder={placeholder ? placeholder : ""}
                  disabled={disabled}
                  pattern={this.props.regExPattern}
                  onKeyUp={(e)=> { 
                    if (e.keyCode === 13){
                      if (this.props.onSubmit) this.props.onSubmit(e);
                    } 
                  }}
                />
                &nbsp;<div style={{display: 'flex'}}>{this.props.children}&nbsp;{ this.props.mandatory && <div style={{color:"red"}}>*</div>}</div>
              </div>
                {
                  this.props.validation[this.props.name] && this.props.validation[this.props.name].map((v, i) => {
                    return(<div key={i}  className="error_message">{local[v]}</div>)
                  })
                }
            </React.Fragment>
        );
    }
}

export const CheckBox = withRouter(
  connect(
      mapStateToProps,
      mapDispatchToProps
  )(_CheckBox)
);